export const stagingEnvConfig = {
  DISABLED_CONSOLE_MSG: false,
  YOLO_BASE_URL: 'https://yolorekt.finance',
  BASE_BRANCH: 'staging',

  // CRYPTO
  APPROVED_CHAINS_IDS: [137],

  //BACKEND CONNECTION
  YOLO_API_BASE_URL: 'https://temp-api.yolorekt.finance',
  BACKEND_SOCKET_URL: 'https://prod.yolorekt.finance',
  CONTRACTS_VERSION: '32',
}
